import { Icon } from '@iconify/react'
import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getMessageCount } from '../../../redux/slices/notifications'
import { toogle } from '../../../redux/slices/sidebar'
import { Menu } from '@headlessui/react'
import Avatar from '../chat/avatar'
import { useLocation, useNavigate } from 'react-router-dom'
import { getdoctorinfo } from '../../../redux/actions/passActions'
import { DoctorDetailsRequest, logoutUserAction } from '../../../redux/actions/authActions'
import { logout } from '../../../redux/slices/authenticate'
import { GetUrgentRequestList } from '../../../utils/services/patient'

const Navbar = () => {
  const store = useSendbirdStateContext()
  var sdk = store?.stores.sdkStore.sdk
  const [total, setTotal] = useState(0)
  const [firstName, setFirstName] = useState('')
  const [secondName, setSecondName] = useState('')
  const [hasUrgentPatients, setHasUrgentPatients] = useState(false)
  
  const { messagesCount } = useSelector((state) => state.notification)
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  
  const handleSearchButtonClick = () => {
    const option = {
      state: { "search_key": searchQuery }
    };
    if (searchQuery) {
      navigate('/patientList', option);
      setSearchQuery('');
    }
  };
  
  const dispatch = useDispatch()
  const handleToggle = () => {
    dispatch(toogle())
  }

  const { docinfo } = useSelector((state) => state.pass)
  const { userToken, userInfo, doctorDetails } = useSelector((state) => state.auth)

  useEffect(() => {
    dispatch(getdoctorinfo({ token: userToken, docid: userInfo.id }))
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    dispatch(DoctorDetailsRequest({ id: userInfo?.id }))
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    const fetchUrgentData = async () => {
      if (userInfo?.id) {
        try {
          const payload = { 
            practitioner_id: userInfo.id.toString(),
            user_type: userInfo?.doctor_login?.user_type,
            status: "active",
            patient_login: "1",
            page: 1 
          };
          
          const response = await GetUrgentRequestList(payload);
          
          if (response?.data?.result === "success") {
            const dataArray = response.data.data || [];
            setHasUrgentPatients(dataArray.length > 0);
          }
        } catch (error) {
          console.error("Error fetching urgent request data:", error);
        }
      }
    };

    fetchUrgentData();
  }, [userInfo?.id]); 

  const navigate = useNavigate()

  const fetchChannels = async () => {
    let sendbird = sdk
    let query = sendbird.groupChannel.createMyGroupChannelListQuery({
      limit: 10,
      order: 'latest_last_message',
    })
    const fetchedChannels = await query.next()
    dispatch(getMessageCount(fetchedChannels))
  }
  
  const handleLogoutClick = () => {
    const userType = userInfo?.doctor_login?.user_type?.length > 0 
      ? userInfo.doctor_login.user_type 
      : null;

    dispatch(logoutUserAction({
      practitioner_id: userInfo?.id,
      user_type: userType,
      callBack: () => {
        localStorage.clear()
        dispatch(logout());
        navigate('/login')
      }
    }));
  };
  
  useEffect(() => {
    if (!sdk || !sdk.groupChannel) {
      return
    }
    fetchChannels()
    //eslint-disable-next-line
  }, [sdk])

  useEffect(() => {
    const sumOfUnread = messagesCount.reduce(
      (sum, message) => sum + message.unreadMessageCount,
      0
    )
    setTotal(sumOfUnread)
  }, [messagesCount])

  useEffect(() => {
    if (docinfo) {
      const [firstLetter, secondletter] = docinfo?.name?.split(" ").map((part) => part.charAt(0).toUpperCase());
      setFirstName(firstLetter)
      setSecondName(secondletter)
    }
  }, [docinfo])

  const goToMessagesPage = () => {
    navigate('/chat')
  }

  const triggerPageTour = () => {
    window.dispatchEvent(new CustomEvent('trigger-active-tour'));
  };

  const hideSearch = location.pathname === '/patientList' || location.pathname.includes("/patientDetails");

  return (
    <div className="w-full h-16 flex items-center gap-4 px-6 bg-white border-b border-gray-200 z-40">
      {/* Menu toggle */}
      <section>
        <button
          onClick={handleToggle}
          className="p-2 -ml-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
        >
          <Icon icon="tabler:menu-2" width={22} height={22} />
        </button>
      </section>

      {/* Search */}
      <section className="flex-1 max-w-xl">
        {!hideSearch && (
          <div className="relative">
            <Icon
              icon="tabler:search"
              width={18}
              height={18}
              className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
            />
            <input
              type="text"
              placeholder="Search patients"
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={(e) => e.key === 'Enter' && handleSearchButtonClick()}
              className="w-full py-2.5 pl-10 pr-4 rounded-full bg-gray-50 border border-gray-200 text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-everglade-500 focus:border-transparent transition-shadow"
            />
          </div>
        )}
      </section>

      {/* Right icon cluster */}
      <section className="flex items-center gap-1 ml-auto">
        <button
          onClick={() => hasUrgentPatients && navigate('/urgentList')}
          className="relative p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
          title={hasUrgentPatients ? "Urgent requests" : "Notifications"}
        >
          <Icon icon="tabler:bell" width={22} height={22} />
          {hasUrgentPatients && (
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full ring-2 ring-white" />
          )}
        </button>

        <button
          onClick={triggerPageTour}
          className="p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
          title="Show Page Tour"
        >
          <Icon icon="tabler:help-circle" width={22} height={22} />
        </button>

        <button
          onClick={goToMessagesPage}
          className="relative p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
          title="Messages"
        >
          <Icon icon="tabler:message-circle" width={22} height={22} />
          {total > 0 && (
            <span className="absolute top-0.5 right-0.5 min-w-[16px] h-4 px-1 bg-red-500 rounded-full flex items-center justify-center text-white text-[10px] font-bold leading-none">
              {total}
            </span>
          )}
        </button>

        {/* Avatar + name */}
        <Menu as="div" className="relative ml-1">
          <Menu.Button className="flex items-center gap-2 pl-1.5 pr-3 py-1.5 rounded-full hover:bg-gray-100 transition-colors">
            {!(doctorDetails?.data?.profile_image) ? (
              <Avatar fname={firstName} lname={secondName} width={"w-9 h-9"} />
            ) : (
              <Avatar
                image={doctorDetails?.data?.profile_image}
                width={"w-9 h-9"}
                profile={true}
              />
            )}
            <span className="hidden sm:block text-sm font-medium text-gray-800 max-w-[140px] truncate">
              {docinfo?.name || 'Doctor'}
            </span>
            <Icon icon="tabler:chevron-down" width={16} height={16} className="hidden sm:block text-gray-400" />
          </Menu.Button>
          <Menu.Items
            className="fixed z-10 h-fit right-4 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-xl shadow-lg border border-gray-100 focus:outline-none overflow-hidden"
            style={{ zIndex: 5 }}
          >
            <div className="px-1 py-1 flex flex-col">
              {userInfo && userInfo.doctor_login && userInfo.doctor_login.user_type && userInfo.doctor_login.user_type.length > 0 ? null : (
                <Menu.Item>
                  {({ active }) => (
                    <p
                      className={`${active ? 'bg-everglade-50 text-everglade-700' : 'text-gray-700'} px-3 py-2 rounded-lg text-sm cursor-pointer transition-colors`}
                      onClick={() => navigate('/profile')}
                    >
                      Profile
                    </p>
                  )}
                </Menu.Item>
              )}
              <Menu.Item>
                {({ active }) => (
                  <p
                    className={`${active ? 'bg-everglade-50 text-everglade-700' : 'text-gray-700'} px-3 py-2 rounded-lg text-sm cursor-pointer transition-colors`}
                    onClick={() => navigate('/setting/change-password')}
                  >
                    Change password
                  </p>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <p
                    className={`${active ? 'bg-red-50 text-red-600' : 'text-gray-700'} px-3 py-2 rounded-lg text-sm cursor-pointer transition-colors`}
                    onClick={handleLogoutClick}
                  >
                    Logout
                  </p>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Menu>
      </section>
    </div>
  )
}

export default Navbar